import { render } from "./DisplayResult.vue?vue&type=template&id=147cdfff&scoped=true"
import script from "./DisplayResult.vue?vue&type=script&lang=js"
export * from "./DisplayResult.vue?vue&type=script&lang=js"

import "./DisplayResult.vue?vue&type=style&index=0&id=147cdfff&scoped=true&lang=scss"
/* hot reload */
if (module.hot) {
  script.__hmrId = "147cdfff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('147cdfff', script)) {
    api.reload('147cdfff', script)
  }
  
  module.hot.accept("./DisplayResult.vue?vue&type=template&id=147cdfff&scoped=true", () => {
    api.rerender('147cdfff', render)
  })

}


import exportComponent from "/data/tfs-agent-build-3/agent/_work/2/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147cdfff"],['__file',"src/components/DisplayResult.vue"]])